import AuthService, { Bootstrap } from '@hotmart/cas-js';
import { PossibleStorages } from '@hotmart/cas-js/dist/auth.service';
import ColaboratorTokenStrategy from './tokenStrategies/colaboratorTokenStrategy';

const surrogateEnabled = () => sessionStorage.getItem('surrogate-enabled') === 'true';

const CAS_USER_STORE = surrogateEnabled() ?
  PossibleStorages.sessionStorage : PossibleStorages.localStorage;

const CAS_AUTHORITY = surrogateEnabled() ?
  process.env.CAS_SURROGATE_URL : process.env.CAS_URL;

const authService = new AuthService({
  env: process.env.NODE_ENV === 'production' ? 'production' : 'development',
  client_id: process.env.CAS_AUTH_CLIENT_ID,
  authority: `${CAS_AUTHORITY}/oidc`,
  storeToUse: CAS_USER_STORE,
  scope: 'openid profile email authorities user',
});

const bootstrapConfig = { appName: 'klickart-analytics-client' };
const bootstrap = new Bootstrap(authService, bootstrapConfig);

const casEnabled = () => {
  const casAuthEnabled = process.env.CAS_AUTHENTICATION_ENABLED === 'true';

  return casAuthEnabled;
};

const isColaborator = () => {
  if (process.env.DISABLE_COLABORATOR_COOKIE === 'true') {
    return false;
  }

  const colaboratorTokenStrategy = new ColaboratorTokenStrategy();
  const colaboratorToken = colaboratorTokenStrategy.getToken();

  return colaboratorToken !== undefined && colaboratorToken !== null;
};

export { bootstrap, casEnabled, surrogateEnabled, isColaborator };
export default authService;



// WEBPACK FOOTER //
// ./src/auth/authService.js